"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreAreaChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreAreaChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreAreaChart, _super);
    function CoreAreaChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreAreaChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "area" }, this.props));
    };
    return CoreAreaChart;
}(react_1.default.PureComponent));
exports.CoreAreaChart = CoreAreaChart;
//# sourceMappingURL=CoreAreaChart.js.map